import { Routes, Route, Navigate } from 'react-router-dom';
import NotFound from '../shared/component/NotFound';
import AccessDenied from '../shared/component/AccessDenied';
import HomeCRM from '../components/home/homeCRM';
import Accounts from '../components/accounts/accounts';
import Contacts from '../components/contacts/contacts';
import Deals from '../components/deals/deals';
import Leads from '../components/leads/leads';
import Tasks from '../components/tasks/tasks';
import Meetings from '../components/meetings/meetings';
import Calls from '../components/calls/calls';
import Campaigns from '../components/campaigns/campaigns';
import ViewLead from '../components/leads/viewLead';
import ViewContact from '../components/contacts/viewContact';
import ViewAccount from '../components/accounts/viewAccount';
import ViewDeal from '../components/deals/viewDeal';
import ImportLead from '../components/leads/importLead';
import ImportCampaign from '../components/campaigns/importCampaign';
import ViewCampaigns from '../components/campaigns/viewCampaigns';
import ViewMeetings from '../components/meetings/viewMeetings';
import ViewTasks from '../components/tasks/viewTasks';
import ViewCalls from '../components/calls/viewCalls';
import AddLead from '../components/leads/addLead';
import ConvertLead from '../components/leads/convertLead';
import AddContactsForm from '../components/contacts/addContactsForm';
import AddAccountsForm from '../components/accounts/addAccountsForm';
import AddDeals from '../components/deals/addDeals';
import AddCampaignForm from '../components/campaigns/addCampaignForm';
import Settings from '../components/settings/settings';
import AddTasksForm from '../components/tasks/addTasksForm';
import TemplateGallery from '../components/settings/emailTemplate/templateGallery';
import ImportContact from '../components/contacts/importContact';
import EmailTemplateBuilder from '../components/settings/emailTemplate/emailTemplateBuilder';
import MassEmailPage from '../components/leads/massEmailpage';
import ManageTagPage from '../components/leads/manageTagPage';
import ImportDeal from '../components/deals/importDeal';
import PersonalSettings from '../components/settings/personalSettings';
import User from '../components/settings/user';
import Profile from '../components/settings/profile';
import Roles from '../components/settings/roles';
import Templates from '../components/settings/emailTemplate/templates';
import ConvertLeadSuccess from '../components/leads/convertLeadSuccess';
import ImportAccount from '../components/accounts/importAccount';
import QuoteList from '../quoteAI/components/quote/quoteList';
import Dashboard from '../quoteAI/components/quote/dashboard';
import InsuredInformationPage from '../quoteAI/components/quote/insuredInformation';
import SidebarQuoteAi from '../quoteAI/components/quote/sidebarQuoteAi';
import ContactInformationPage from '../quoteAI/components/quote/contactInformation';
import PolicyTermPage from '../quoteAI/components/quote/policyTerm';
import LocationPage from '../quoteAI/components/quote/location';
import LocationClassCodePage from '../quoteAI/components/quote/locationClassCode';
import PreQualifierQuestionPage from '../quoteAI/components/quote/preQualifierQuestion';
import RatingInformationPage from '../quoteAI/components/quote/ratingInformation';
import DeductiblePage from '../quoteAI/components/quote/deductible';
import LossDetailPage from '../quoteAI/components/quote/lossDetail';
import IncludedExcludedOfficerPage from '../quoteAI/components/quote/includedExcludedOfficer';
import UnderwritingInformationPage from '../quoteAI/components/quote/underwritingInformation';
import AdditionalFormPage from '../quoteAI/components/quote/additionalForm';
import QuotedPremiumPage from '../quoteAI/components/quote/quotedPremium';
import HeaderQuoteAi from '../quoteAI/components/quote/headerQuoteAi';
import RightHeaderPage from '../quoteAI/components/quote/rightHeader';
import FullWorkBookPage from '../quoteAI/components/quote/fullWorkBook';
import MaintenancePage from '../components/common/maintenance';

import HeaderQuoteAiView from '../quoteAI/components/quote/headerquoteAiView';
import InsuredInformationViewPage from '../quoteAI/components/quote/insuredInformationViewPage';
import SidebarQuoteAiViewPage from '../quoteAI/components/quote/sidebarquoteAiView';
import ContactInformationViewPage from '../quoteAI/components/quote/contactInformationViewPage';
import PolicyTermViewPage from '../quoteAI/components/quote/policyTermViewPage';
import AlfredAlertPage from '../quoteAI/components/quote/alfredAlertPage';

import UserManagementList from '../components/userManagement/userManagementList';
import UiPermissionsList from '../components/uiPermissions/uiPermissionList';
import ActionPermissionList from '../components/actionPermission/actionPermissionList';
import RoleManagement from '../components/roleManagement/roleManagement';
import RegularQuote from '../quoteAI/components/quote/regularQuote';
import RegularQuoteEdit from '../quoteAI/components/quote/regularQuoteEdit';
import Sales from '../components/sales/sales';
import ViewSales from '../components/sales/viewsales';
import SalesGrid from '../components/sales/salesGrid';
import SmartSequence from '../components/campaigns/smartSequence';
import Products from '../components/products/products';
import ProductListing from '../components/products/productListing';
import PriceListing from '../components/products/priceListing';
import ViewProduct from '../components/products/viewProduct';
import ViewPricelist from '../components/products/viewPricelist';
import AddSales from '../components/sales/addSales';
import AddProduct from '../components/products/addProduct';
import AddPriceList from '../components/products/addPrice';
import RegularQuoteView from '../quoteAI/components/quote/regularQuoteView';
import AddInvoice from '../components/sales/invoice/addInvoice';
import InvoiceGrid from '../components/sales/invoice/invoiceGrid';
import ViewInvoice from '../components/sales/invoice/viewInvoice';
import QuoteAiDashboard from '../quoteAI/components/quote/quoteAiDashboard';
import UserActivity from '../components/userActivity/userActivity';
import AddSmartSequence from '../components/campaigns/addSmartSequence';
import AuditLog from '../components/settings/auditLog';
import AttendanceInfoCalendar from '../components/attendanceCalendar/attendanceInfoCalendar';

// Define paths for wrappers
export const wrapperCrmPaths = [
  '/dashboard',
  '/leads',
  '/accounts',
  '/opportunity',
  '/tickets',
  '/contacts',
  '/meetings',
  '/calls',
  '/campaigns',
  '/settings',
  '/leads/CreateNew',
  '/leads/editLead',
  '/leads/convertLead',
  '/leads/convertLead=Success',
  '/leads/viewLead',
  '/accounts/addAccount',
  '/accounts/editAccount',
  '/accounts/viewAccount',
  '/accounts/manageTags',
  '/opportunity/viewDeal',
  '/opportunity/manageTags',
  '/contacts/addContact',
  '/contacts/editContact',
  '/contacts/viewContact',
  '/contacts/manageTags',
  '/leads/importLead',
  '/contacts/importContact',
  '/campaigns/addCampaign',
  '/campaigns/editCampaign',
  '/campaigns/viewCampaign',
  '/campaigns/manageTags',
  '/campaigns/smartSequence',

  '/meetings/viewMeetings',
  '/tickets/editTicket',
  '/tickets/addTicket',
  '/tickets/viewTicket',
  '/tickets/manageTags',
  '/calls/viewCalls',
  '/maintenance',

  '/opportunity/editOpportunity',
  '/opportunity/addOpportunity',
  '/opportunity/viewOpportunity',
  '/opportunity/importOpportunity',
  '/settings/templateGallery',
  '/settings/personalSettings',
  '/settings/users',
  '/profiles',
  '/settings/roles',
  '/settings/emails',
  '/settings/templates',
  '/settings/templateGallery/newTemplate',
  '/settings/templateGallery/updateTemplate',
  '/leads/massEmailPage',
  '/contacts/massEmailPage',
  '/leads/manageTags',
  '/campaigns/importCampaign',
  '/accounts/importAccount',
  '/quoteAI',
  '/quoteAI',
  '/quoteAI/regularQuote',
  '/quoteAI/regularQuoteEdit',
  '/quoteAI/regularQuoteAdd',
  '/sales/salesOrder',
  '/sales/salesGrid',
  '/sales/invoiceGrid',
  '/sales/createSalesOrder',
  '/sales/createInvoice',
  '/sales/viewSalesOrder',
  '/sales/viewInvoice',

  '/products',
  '/products/productsListing',
  '/products/priceListing',
  '/products/productList/createProduct',
  '/products/productList/viewProduct',
  '/products/createPricelist',
  '/products/viewPricelist',

  '/campaigns/createSmartSequence',

  '*', // Catch-all route
  '/unauthorized',
];

const ProtectedPagesCRM = ({ userPermission }) => {
  const role = userPermission?.role || '';
  const isAdminOrSystemManager = role === 'Admin' || role === 'System Manager';
  const isSystemManager = role === 'System Manager';
  return (
    <Routes>
      {/* Define your CRM routes here */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<HomeCRM />} />
      <Route path="/login" element={<Navigate to="/dashboard" replace />} />
      <Route path="/profiles" element={<Profile />} />
      <Route path="/meetings" element={<Meetings />} />
      <Route path="/meetings/viewMeetings" element={<ViewMeetings />} />
      <Route path="/meetings/addMeetings"></Route>
      <Route path="/calls/viewCalls" element={<ViewCalls />} />
      <Route path="/calls" element={<Calls />} />
      <Route path="/maintenance" element={<MaintenancePage />} />
      <Route path="/attendanceInfo" element={<AttendanceInfoCalendar />} />
      {userPermission?.menues['campaignmenu'] && (
        <Route path="/campaigns" element={<Campaigns />} />
      )}

      {/* <Route path="/settings" element={<Settings />} /> */}
      {isAdminOrSystemManager && <Route path="/settings" element={<PersonalSettings />} />}
      {isAdminOrSystemManager && <Route path="/settings/users" element={<UserManagementList />} />}
      {isAdminOrSystemManager && (
        <Route path="/settings/uiPermissions" element={<UiPermissionsList />} />
      )}
      {isAdminOrSystemManager && (
        <Route path="/settings/actionPermissions" element={<ActionPermissionList />} />
      )}
      {isAdminOrSystemManager && (
        <Route path="/settings/roleManagement" element={<RoleManagement />} />
      )}
      {isAdminOrSystemManager && (
        <Route path="/settings/userActivity" element={<UserActivity />} />
      )}
      {isAdminOrSystemManager && <Route path="/settings/roles" element={<Roles />} />}
      {isAdminOrSystemManager && <Route path="/settings/emails" element={<Settings />} />}
      {isAdminOrSystemManager && <Route path="/settings/templates" element={<Templates />} />}
      {isAdminOrSystemManager && <Route path="/settings/auditLog" element={<AuditLog />} />}
      {isAdminOrSystemManager && (
        <Route path="/settings/templateGallery" element={<TemplateGallery />} />
      )}
      {isAdminOrSystemManager && (
        <Route path="/settings/templateGallery/newTemplate" element={<EmailTemplateBuilder />} />
      )}
      {isAdminOrSystemManager && (
        <Route path="/settings/templateGallery/updateTemplate" element={<EmailTemplateBuilder />} />
      )}
      <Route path="/unauthorized" element={<AccessDenied />} />

      {userPermission?.menues['leadmenu'] && <Route path="/leads" element={<Leads />} />}
      {userPermission?.menues['leadmenu'] && (
        <Route path="/leads/CreateNew" element={<AddLead />} />
      )}
      {userPermission?.menues['leadmenu'] && <Route path="/leads/editLead" element={<AddLead />} />}
      {userPermission?.menues['leadmenu'] && (
        <Route path="/leads/convertLead" element={<ConvertLead />} />
      )}
      {userPermission?.menues['leadmenu'] && (
        <Route path="/leads/convertLead=Success" element={<ConvertLeadSuccess />} />
      )}
      {userPermission?.menues['leadmenu'] && (
        <Route path="/leads/viewLead" element={<ViewLead />} />
      )}
      {userPermission?.menues['leadmenu'] && (
        <Route path="/leads/importLead" element={<ImportLead />} />
      )}
      {userPermission?.menues['leadmenu'] && (
        <Route path="/leads/massEmailPage" element={<MassEmailPage />} />
      )}
      {userPermission?.menues['leadmenu'] && (
        <Route path="/leads/manageTags" element={<ManageTagPage />} />
      )}

      {userPermission?.menues['contactmenu'] && <Route path="/contacts" element={<Contacts />} />}
      {userPermission?.menues['contactmenu'] && (
        <Route path="/contacts/editContact" element={<AddContactsForm />} />
      )}
      {userPermission?.menues['contactmenu'] && (
        <Route path="/contacts/addContact" element={<AddContactsForm />} />
      )}
      {userPermission?.menues['contactmenu'] && (
        <Route path="/contacts/viewContact" element={<ViewContact />} />
      )}
      {userPermission?.menues['contactmenu'] && (
        <Route path="/contacts/importContact" element={<ImportContact />} />
      )}
      {userPermission?.menues['contactmenu'] && (
        <Route path="/contacts/massEmailPage" element={<MassEmailPage />} />
      )}
      {userPermission?.menues['contactmenu'] && (
        <Route path="/contacts/manageTags" element={<ManageTagPage />} />
      )}

      {userPermission?.menues['accountmenu'] && <Route path="/accounts" element={<Accounts />} />}
      {userPermission?.menues['accountmenu'] && (
        <Route path="/accounts/addAccount" element={<AddAccountsForm />} />
      )}
      {userPermission?.menues['accountmenu'] && (
        <Route path="/accounts/editAccount" element={<AddAccountsForm />} />
      )}
      {userPermission?.menues['accountmenu'] && (
        <Route path="/accounts/viewAccount" element={<ViewAccount />} />
      )}
      {userPermission?.menues['accountmenu'] && (
        <Route path="/accounts/importAccount" element={<ImportAccount />} />
      )}
      {userPermission?.menues['accountmenu'] && (
        <Route path="/accounts/manageTags" element={<ManageTagPage />} />
      )}

      {userPermission?.menues['opportunitymenu'] && (
        <Route path="/opportunity" element={<Deals />} />
      )}
      {userPermission?.menues['opportunitymenu'] && (
        <Route path="/opportunity/editOpportunity" element={<AddDeals />} />
      )}
      {userPermission?.menues['opportunitymenu'] && (
        <Route path="/opportunity/addOpportunity" element={<AddDeals />} />
      )}
      {userPermission?.menues['opportunitymenu'] && (
        <Route path="/opportunity/viewOpportunity" element={<ViewDeal />} />
      )}
      {userPermission?.menues['opportunitymenu'] && (
        <Route path="/opportunity/importOpportunity" element={<ImportDeal />} />
      )}
      {userPermission?.menues['opportunitymenu'] && (
        <Route path="/opportunity/viewDeal" element={<ViewDeal />} />
      )}
      {userPermission?.menues['opportunitymenu'] && (
        <Route path="/opportunity/manageTags" element={<ManageTagPage />} />
      )}

      {userPermission?.menues['campaignmenu'] && (
        <Route path="/campaigns/addCampaign" element={<AddCampaignForm />} />
      )}
      {userPermission?.menues['campaignmenu'] && (
        <Route path="/campaigns/editCampaign" element={<AddCampaignForm />} />
      )}
      {userPermission?.menues['campaignmenu'] && (
        <Route path="/campaigns/viewCampaign" element={<ViewCampaigns />} />
      )}
      {userPermission?.menues['campaignmenu'] && (
        <Route path="/campaigns/importCampaign" element={<ImportCampaign />} />
      )}
      {userPermission?.menues['campaignmenu'] && (
        <Route path="/campaigns/manageTags" element={<ManageTagPage />} />
      )}
      {userPermission?.menues['campaignmenu'] && (
        <Route path="/campaigns/smartSequence" element={<Campaigns />} />
      )}
      {userPermission?.menues['campaignmenu'] && (
        <Route path="/campaigns/createSmartSequence" element={<AddSmartSequence />} />
      )}
      {userPermission?.menues['campaignmenu'] && (
        <Route path="/campaigns/editSmartSequence" element={<AddSmartSequence />} />
      )}
      {userPermission?.menues['campaignmenu'] && (
        <Route path="/campaigns/viewSmartSequence" element={<AddSmartSequence />} />
      )}

      {userPermission?.menues['ticketmenu'] && <Route path="/tickets" element={<Tasks />} />}
      {userPermission?.menues['ticketmenu'] && (
        <Route path="/tickets/addTicket" element={<AddTasksForm />} />
      )}
      {userPermission?.menues['ticketmenu'] && (
        <Route path="/tickets/editTicket" element={<AddTasksForm />} />
      )}
      {userPermission?.menues['ticketmenu'] && (
        <Route path="/tickets/viewTicket" element={<ViewTasks />} />
      )}
      {userPermission?.menues['ticketmenu'] && (
        <Route path="/tickets/manageTags" element={<ManageTagPage />} />
      )}
      {userPermission?.menues['ticketmenu'] && <Route path="/tickets/addTasks"></Route>}

      {userPermission?.menues['quotemenu'] && <Route path="/quoteAI" element={<Dashboard />} />}
      {userPermission?.menues['quotemenu'] && (
        <Route path="pncQuote/dashboard" element={<QuoteAiDashboard />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/regularQuoteView" element={<RegularQuoteView />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/regularQuoteEdit" element={<RegularQuoteEdit />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/regularQuoteAdd" element={<RegularQuoteEdit />} />
      )}
      {userPermission?.menues['quotemenu'] && <Route path="/quoteAI" element={<QuoteList />} />}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/insuredInformationPage" element={<InsuredInformationPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/sidebarQuoteAi" element={<SidebarQuoteAi />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/contactInformationPage" element={<ContactInformationPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/policyTermPage" element={<PolicyTermPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/locationPage" element={<LocationPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/locationClassCodePage" element={<LocationClassCodePage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/preQualifierQuestionPage" element={<PreQualifierQuestionPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/ratingInformationPage" element={<RatingInformationPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/deductiblePage" element={<DeductiblePage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/lossDetailPage" element={<LossDetailPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route
          path="/quoteAI/includedExcludedOfficerPage"
          element={<IncludedExcludedOfficerPage />}
        />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route
          path="/quoteAI/underwritingInformationPage"
          element={<UnderwritingInformationPage />}
        />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/additionalFormPage" element={<AdditionalFormPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/quotedPremiumPage" element={<QuotedPremiumPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/headerQuoteAi" element={<HeaderQuoteAi />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/rightHeaderPage" element={<RightHeaderPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/fullWorkBookPage" element={<FullWorkBookPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/alfredAlertPage" element={<AlfredAlertPage />} />
      )}

      {/* ***********view details page ************************* */}

      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/sidebarQuoteAiViewPage" element={<SidebarQuoteAiViewPage />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/headerQuoteAiView" element={<HeaderQuoteAiView />} />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route
          path="/quoteAI/insuredInformationViewPage"
          element={<InsuredInformationViewPage />}
        />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route
          path="/quoteAI/contactInformationViewPage"
          element={<ContactInformationViewPage />}
        />
      )}
      {userPermission?.menues['quotemenu'] && (
        <Route path="/quoteAI/policyTermViewPage" element={<PolicyTermViewPage />} />
      )}

      {/* ***********Sales page ************************* */}
      {userPermission?.menues['salemenu'] && <Route path="/sales/salesOrder" element={<Sales />} />}
      {userPermission?.menues['salemenu'] && <Route path="/sales/invoice" element={<Sales />} />}
      {userPermission?.menues['salemenu'] && (
        <Route path="/sales/salesGrid" element={<SalesGrid />} />
      )}
      {userPermission?.menues['salemenu'] && (
        <Route path="/sales/invoiceGrid" element={<InvoiceGrid />} />
      )}
      {userPermission?.menues['salemenu'] && (
        <Route path="/sales/createSalesOrder" element={<AddSales />} />
      )}
      {userPermission?.menues['salemenu'] && (
        <Route path="/sales/editSalesOrder" element={<AddSales />} />
      )}
      {userPermission?.menues['salemenu'] && (
        <Route path="/sales/createInvoice" element={<AddInvoice />} />
      )}
      {userPermission?.menues['salemenu'] && (
        <Route path="/sales/editInvoice" element={<AddInvoice />} />
      )}
      {userPermission?.menues['salemenu'] && (
        <Route path="/sales/viewSalesOrder" element={<ViewSales />} />
      )}
      {userPermission?.menues['salemenu'] && (
        <Route path="/sales/viewInvoice" element={<ViewInvoice />} />
      )}

      {/* ***********Product page ************************* */}
      {userPermission?.menues['productmenu'] && (
        <Route path="/products/productList" element={<Products />} />
      )}
      {/* {userPermission?.menues["productmenu"] && (
        <Route path="/products/productListing" element={<ProductListing />} />
      )} */}
      {userPermission?.menues['productmenu'] && (
        <Route path="/products/priceSheet" element={<Products />} />
      )}
      {userPermission?.menues['productmenu'] && (
        <Route path="/products/productList/createProduct" element={<AddProduct />} />
      )}
      {userPermission?.menues['productmenu'] && (
        <Route path="/products/productList/editProduct" element={<AddProduct />} />
      )}
      {userPermission?.menues['productmenu'] && (
        <Route path="/products/productList/viewProduct" element={<ViewProduct />} />
      )}
      {userPermission?.menues['productmenu'] && (
        <Route path="/products/priceSheet/createPriceSheet" element={<AddPriceList />} />
      )}
      {userPermission?.menues['productmenu'] && (
        <Route path="/products/priceSheet/editPriceSheet" element={<AddPriceList />} />
      )}
      {userPermission?.menues['productmenu'] && (
        <Route path="/products/priceSheet/viewPriceSheet" element={<ViewPricelist />} />
      )}

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default ProtectedPagesCRM;
